













































































































import Vue from 'vue';
import EventField from './EventField.vue';
import SelectRemarkBox from '../../../../customer/components/remarks/SelectRemarkBox.vue';
import CustomerRemark from '../../../../customer/models/CustomerRemark';
import MemberCardLevel from '../../../../customer/models/MemberCardLevel';
import customerClient from '../../../../customer/apis';
import scheduleRuleVuex from '../../../vuex/common';
import customerVuex from '../../../../customer/vuex/common';
import {
  ScheduleEventType,
  TraceEventType,
} from '../../../models/ScheduleEventParam';
import Tab from '@/common/components/ui/Tab/index.vue';

interface EventRemark {
  remarkId: number;
  remarkName: string;
}
const repeatFollowOpts = [{
  label: '仅首次关注触发',
  value: false,
},{
  label: '反复关注也触发',
  value: true,
}];

const eventType: ScheduleEventType | undefined = undefined;
const targetMemberLevel: MemberCardLevel | undefined = undefined;
const selectedRemark: EventRemark | undefined = undefined;

export default Vue.extend({
  mixins: [scheduleRuleVuex, customerVuex],
  components: {
    EventField,
    SelectRemarkBox,
    Tab,
  },
  computed: {
    isVerifiedService(): boolean {
      return this.accountState.account.weixinType === 1 &&
             this.accountState.account.isVerified;
    },
  },
  props: {
    eventTriggered: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      followRepeat: false,
      TraceEventType,
      showRemarkBox: false,
      traceEnabled: false,
      scoreReached: 0,
      selectedRemark,
      targetMemberLevel,
      ScheduleEventType,
      eventType,
      targetTrace: 7,
      repeatFollowOpts,
    };
  },
  methods: {
    repeatStateChange(v: boolean) {
      this.followRepeat = v;
    },
    confirmRemarkBox(selectedRemark: CustomerRemark) {
      this.selectedRemark = {
        remarkId: selectedRemark.id,
        remarkName: selectedRemark.remarkName,
      } as EventRemark;
      this.showRemarkBox = false;
    },
    isEventRemarkAppended(): boolean {
      const eventType = this.scheduleRule.ruleContext.eventType;
      return eventType === ScheduleEventType.RemarkAppended; 
    },
    isScoreReached(): boolean {
      const eventType = this.scheduleRule.ruleContext.eventType;
      return eventType === ScheduleEventType.ScoreReached; 
    },
    isMemberLevelUp(): boolean {
      const eventType = this.scheduleRule.ruleContext.eventType;
      return eventType === ScheduleEventType.MemberLevelUp;
    },
    isTraceAppended(): boolean {
      const eventType = this.scheduleRule.ruleContext.eventType;
      return eventType === ScheduleEventType.TraceAppended;
    },
    loadMemberCards() {
      customerClient.getMemberCards().success((r: any) => {
        this.$store.commit('SET_MEMBER_CARDS', r);
      });
    },
    confirmEventSettings() {
      if (this.validateEventSettings()) {
        const eventTriggered = JSON.parse(JSON.stringify(this.scheduleRule.ruleContext.EventTriggered));
        eventTriggered.eventType = this.eventType;
        if (this.eventType === ScheduleEventType.RemarkAppended) {
          eventTriggered.param = {
            RemarkAppended: {
              remarkId: (this.selectedRemark as any).remarkId,
              remarkName: this.selectedRemark.remarkName,
            },
          };
        } else if (this.eventType === ScheduleEventType.ScoreReached) {
          eventTriggered.param = {
            ScoreReached: {
              score: this.scoreReached,
            },
          };
        } else if (this.eventType === ScheduleEventType.MemberLevelUp) {
          const level = this.customerState.memberCards.find((card: any) => {
            return card.level === this.targetMemberLevel!;
          });
          eventTriggered.param = {
            MemberLevelUp: {
              level: level!.level,
              title: level!.title,
            },
          };
        } else if (this.eventType === ScheduleEventType.TraceAppended) {
          eventTriggered.param = {
            TraceAppended: {
              traceOuterType: this.targetTrace,
            },
          };
        } else if (this.eventType === ScheduleEventType.Follow) {
          eventTriggered.param = {
            Follow: {
              repeat: this.followRepeat === true,
            },
          };
        }
        this.$store.commit('UPDATE_SCHEDULE_EVENT_TRIGGERED', eventTriggered);
        this.$emit('close');
      }
    },
    validateEventSettings(): boolean {
      if (!this.eventType) {
        this.$Message.warning('请选择事件类型');
        return false;
      }
      switch (this.eventType) {
        case ScheduleEventType.RemarkAppended: {
          if (!this.selectedRemark) {
            this.$Message.warning('请选择标签');
            return false;
          } else {
            return true;
          }
        }
        case ScheduleEventType.ScoreReached: {
          if (!this.scoreReached || this.scoreReached < 1) {
            this.$Message.warning('请填写正确的积分数量');
            return false;
          } else {
            return true;
          }
        }
        case ScheduleEventType.MemberLevelUp: {
          if (!this.targetMemberLevel) {
            this.$Message.warning('请选择会员等级');
            return false;
          } else {
            return true;
          }
        }
        case ScheduleEventType.TraceAppended: {
          if (!this.targetTrace) {
            this.$Message.warning('请选择轨迹');
            return false;
          } else {
            return true;
          }
        }
        default: {
          return true;
        }
      }
    },
    initEventTriggered() {
      if (this.eventTriggered.eventType) {
        const etd = JSON.parse(JSON.stringify(this.eventTriggered));
        this.scoreReached = etd.param.score || 0;
        this.selectedRemark = etd.param.RemarkAppended || undefined;
        this.eventType = etd.eventType;
        if (etd.param.ScoreReached) {
          this.scoreReached = etd.param.ScoreReached.score;
        }
        if (etd.param.MemberLevelUp) {
          this.targetMemberLevel = etd.param.MemberLevelUp.level;
        }
        if (etd.param.TraceAppended) {
          this.targetTrace = etd.param.TraceAppended.traceOuterType;
        }
        if(etd.param.Follow) {
          console.log(`init followRepeat ${etd.param.Follow}`);
          this.followRepeat = etd.param.Follow.repeat === true;
        }
      }
    },
    getTraceStatus() {
      customerClient.getTraceStatus().success((r: any) => {
        this.traceEnabled = r.enabled;
      });
    },
  },
  mounted() {
    this.loadMemberCards();
    this.initEventTriggered();
    this.getTraceStatus();
  },
});
